import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export const ProductionSupport = () => {
  return <div className="py-20 lg:py-24 bg-white min-h-[calc(100vh-300px)]" data-id="element-987">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-988">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-989">
          <span className="text-sm font-bold uppercase tracking-wider text-brandRed" data-id="element-990">
            Quality & Care
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mt-3 mb-5 leading-tight" data-id="element-991">
            Production & Support
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-992">
            Our production process is built around accuracy, quality control,
            and dedicated USA-based support.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-993">
          <div data-id="element-994">
            <h2 className="text-2xl font-bold text-ink mb-6" data-id="element-995">
              Rigorous Quality Control
            </h2>
            <ul className="space-y-4" data-id="element-996">
              {['Detailed artwork review and setup', 'Accurate color reproduction and matching', 'Verified heat press and sublimation checks', 'Organized sorting by team, size, and roster', 'Final inspection of every piece before shipping'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-600" data-id="element-997">
                  <CheckCircle2 className="w-6 h-6 text-brandRed shrink-0" data-id="element-998" />
                  <span className="leading-relaxed" data-id="element-999">{item}</span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-1000">
            <h2 className="text-2xl font-bold text-ink mb-6" data-id="element-1001">
              Dedicated Support Team
            </h2>
            <ul className="space-y-4" data-id="element-1002">
              {['USA-based support available 9am–10pm EST', 'Assistance with order setup and roster management', 'Direct communication for production updates', 'Help with custom design requests and artwork', 'Drop-ship fulfillment coordination'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-600" data-id="element-1003">
                  <CheckCircle2 className="w-6 h-6 text-brandRed shrink-0" data-id="element-1004" />
                  <span className="leading-relaxed" data-id="element-1005">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
};